import { render, staticRenderFns } from "./SfxFilters.vue?vue&type=template&id=5de8e062&scoped=true"
import script from "./SfxFilters.vue?vue&type=script&lang=js"
export * from "./SfxFilters.vue?vue&type=script&lang=js"
import style0 from "./SfxFilters.vue?vue&type=style&index=0&id=5de8e062&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de8e062",
  null
  
)

export default component.exports